interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

function buildPages(page: number, totalPages: number): (number | string)[] {
  if (totalPages <= 7) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }
  const pages: (number | string)[] = [1];
  const start = Math.max(2, page - 1);
  const end = Math.min(totalPages - 1, page + 1);
  if (start > 2) pages.push("...");
  for (let i = start; i <= end; i += 1) pages.push(i);
  if (end < totalPages - 1) pages.push("...");
  pages.push(totalPages);
  return pages;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  return (
    <nav className="mt-8 flex flex-wrap items-center justify-center gap-2" aria-label="分页导航">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page === 1}
        className="flex h-9 cursor-pointer items-center gap-1 rounded-md border border-background-300 bg-background-50 px-3 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40"
      >
        <i className="ri-arrow-left-s-line" />
        上一页
      </button>

      {buildPages(page, totalPages).map((item, index) =>
        typeof item === "number" ? (
          <button
            key={`p-${item}`}
            type="button"
            onClick={() => onChange(item)}
            className={`h-9 min-w-9 cursor-pointer rounded-md px-3 text-sm font-medium transition-colors ${
              item === page
                ? "bg-accent-500 text-background-50"
                : "border border-background-300 bg-background-50 text-foreground-700 hover:border-primary-400 hover:text-primary-600"
            }`}
          >
            {item}
          </button>
        ) : (
          <span key={`e-${index}`} className="px-1 text-sm text-foreground-400">
            {item}
          </span>
        )
      )}

      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        className="flex h-9 cursor-pointer items-center gap-1 rounded-md border border-background-300 bg-background-50 px-3 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40"
      >
        下一页
        <i className="ri-arrow-right-s-line" />
      </button>
    </nav>
  );
}